import { render, staticRenderFns } from "./CourceModelsDay.vue?vue&type=template&id=1ef79389&scoped=true"
import script from "./CourceModelsDay.vue?vue&type=script&lang=js"
export * from "./CourceModelsDay.vue?vue&type=script&lang=js"
import style0 from "./CourceModelsDay.vue?vue&type=style&index=0&id=1ef79389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef79389",
  null
  
)

export default component.exports